import React from "react";

class GroupTheme {
	constructor(group) {
		this.group = group;
	}

	createGroupArea = (area) => {
		const areaName = `_${area}`;

		if (!this[areaName]) {
			this[areaName] = new GroupAreaTheme(this.group, area);
		}

		return this[areaName];
	};

	primary = () => {
		return this.createGroupArea("primary");
	};

	altprimary = () => {
		return this.createGroupArea("altprimary");
	};

	secondary = () => {
		return this.createGroupArea("secondary");
	};

	contrast = () => {
		return this.createGroupArea("contrast");
	};

	setup = () => {
		return this.createGroupArea("setup");
	};

	button = () => {
		return this.createGroupArea("button");
	};

	experience = () => {
		return this.createGroupArea("experience");
	};

	symptom = () => {
		return this.createGroupArea("symptom");
	};

	qol = () => {
		return this.createGroupArea("qol");
	};

	cost = () => {
		return this.createGroupArea("cost");
	};

	fact = () => {
		return this.createGroupArea("fact");
	};

	gi = () => {
		return this.createGroupArea("gi");
	};

	clinical = () => {
		return this.createGroupArea("clinical");
	};

	prehab = () => {
		return this.createGroupArea("prehab");
	};

	sideEffects = () => {
		return this.createGroupArea("sideEffects");
	};

	registration_lcn = () => {
		return this.createGroupArea("registration_lcn");
	};

	registration_meso = () => {
		return this.createGroupArea("registration_meso");
	};

	lcn = () => {
		return this.createGroupArea("lcn");
	};

	meso = () => {
		return this.createGroupArea("meso");
	};

	mesoperitoneal = () => {
		return this.createGroupArea("mesoperitoneal");
	};

	bkg = () => {
		return `bkg-${this.group}`;
	};
}

class GroupAreaTheme {
	constructor(group, area) {
		this.group = group;
		this.area = area;
	}

	class = (type) => {
		return `${type}-${this.group}-${this.area}`;
	};

	bg = () => {
		return this.class("bg");
	};

	text = () => {
		return this.class("text");
	};

	border = () => {
		return this.class("border");
	};

	from = () => {
		return this.class("from");
	};

	via = () => {
		return this.class("via");
	};
}

export const themes = {
	meso: new GroupTheme("meso"),
	mesoperitoneal: new GroupTheme("mesoperitoneal"),
	lcn: new GroupTheme("lcnuk"),
	generic: new GroupTheme("generic"),
	getTheme: (theme) => {
		if (theme) {
			const result = themes[theme];

			return result ?? themes.default();
		}
		return themes.default();
	},
	default: () => {
		return themes.generic;
	},
};

export const DiseaseGroupContext = React.createContext({
	theme: themes.default(),
	setTheme: () => {},
});

DiseaseGroupContext.displayName = "DieaseGroupContext";
